import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { clearUserSession, loadUserDataFromSession } from '../utils/session-data';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private isLoggedInSubject = new BehaviorSubject<boolean>(false);
  isLoggedIn$ = this.isLoggedInSubject.asObservable();
  baseUrl = environment.baseUrl;

  constructor(private http: HttpClient, private router: Router) {
    this.initializeLoginStatus();
  }

  private async initializeLoginStatus() {
    try {
      const isLoggedIn = this.isLoggedIn();
      this.isLoggedInSubject.next(isLoggedIn);
    } catch (error) {
      console.error('Error initializing login status:', error);
    }
  }

  getToken(): string | null {
    const data = loadUserDataFromSession() as { credentials: { access_token: string } };
  
    if (!data || !data.credentials || !data.credentials.access_token) {
      console.warn('Access token not found in user data.');
      return null;
    }
  
    return data.credentials.access_token;
  }

  isLoggedIn() {    
    return this.getToken() !== null;
  }

  updateLoginStatus(isLoggedIn: boolean) {
    this.isLoggedInSubject.next(isLoggedIn);
  }

  logout() {
    clearUserSession();
    this.updateLoginStatus(false);
    this.router.navigate(['home']);
  }

  otpRequest(body: any): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('content-type', 'application/json');
    return this.http.post(`${this.baseUrl}v1/user/login-otp-request/`, body, { headers })
      .pipe(
        catchError(this.handleError)
      );
  }

  otpVerify(body: any): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('content-type', 'application/json');
    return this.http.post(`${this.baseUrl}v1/user/login-otp/`, body, { headers })
      .pipe(
        catchError(this.handleError)
      );
  }

  registerMethod(body: any, authToken: string): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('content-type', 'application/json');
    headers = headers.set('Authorization', 'Bearer ' + authToken);
    return this.http.post(`${this.baseUrl}v1/user/profile/`, body, { headers })
      .pipe(
        catchError(this.handleError)
      );
  }

  handleError(error: HttpErrorResponse) {
    return throwError(error);
  }
}
